import React from 'react';
import classNames from 'classnames';

import { ReadingIcon, AudioIcon } from 'rebook/apps/base/components/icons/BookIconTransparent';

import styles from './style.scss';


const PaymentsAvailableContentCounters = ({
  isPro, extraClassName,
  isSubscriptionTypeSelected, booksPerSubscriptionCounter,
}) => (
  <div className={classNames(
    styles.counters,
    extraClassName,
    { [styles.countersInner]: isSubscriptionTypeSelected }
  )}>
    <div className={classNames(
      styles.countersItem,
      { [styles.countersItemInner]: isSubscriptionTypeSelected }
    )}>
      <ReadingIcon className={styles.countersIcon} />
      <span className={styles.countersLabel}>
        <span className={styles.countersNumber}>
          {isPro ? booksPerSubscriptionCounter.total : booksPerSubscriptionCounter.standard_free}&nbsp;
        </span>
        книг
      </span>
    </div>
    {isPro && (
      <div className={classNames(
        styles.countersItem,
        styles.countersItemPro,
        { [styles.countersItemInner]: isSubscriptionTypeSelected }
      )}>
        <AudioIcon className={styles.countersIcon} />
        <span className={styles.countersLabel}>
          <span className={styles.countersNumber}>{booksPerSubscriptionCounter.audio}&nbsp;</span>
          аудиокниг
        </span>
      </div>
    )}
  </div>
);

export default PaymentsAvailableContentCounters;
